import React, { Component } from "react";
import PropTypes from "prop-types";
import ColoredHistogramSeries from "./ColoredHistogramSeries";

/**
 * Awesome Oscillator: histograma colorido (barras verdes ao subir, vermelhas ao
 * descer) com linha zero. Fino wrapper sobre o ColoredHistogramSeries genérico
 * — mantém o nome/contrato públicos deste indicador. `yAccessor` retorna
 * `{ value, direction }`.
 */
class AwesomeOscillatorSeries extends Component {
  render() {
    return <ColoredHistogramSeries {...this.props} />;
  }
}

AwesomeOscillatorSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  increasingColor: PropTypes.string.isRequired,
  decreasingColor: PropTypes.string.isRequired,
  strokeZeroLine: PropTypes.object,
  className: PropTypes.string,
  clip: PropTypes.bool,
  onContextMenu: PropTypes.func,
  onDoubleClick: PropTypes.func,
};

AwesomeOscillatorSeries.defaultProps = {
  increasingColor: "#00DD00",
  decreasingColor: "#FF0000",
  strokeZeroLine: { color: "#666666", dash: "Solid", width: 1, opacity: 1 },
  className: "react-stockcharts-awesome-oscillator",
  clip: true,
};

export default AwesomeOscillatorSeries;
